import { Controller } from "@hotwired/stimulus"

// Filtra las cards de /internal/status por texto libre contra
// data-search-text (nombre + descripción, ya en minúsculas).
export default class extends Controller {
  static targets = ["input", "lista"]

  filtrar() {
    const query = this.inputTarget.value.trim().toLowerCase()

    this.listaTargets.forEach(lista => {
      lista.querySelectorAll("[data-search-text]").forEach(card => {
        const visible = query === "" || card.dataset.searchText.includes(query)
        card.toggleAttribute("hidden", !visible)
      })
    })
  }
}
